import Vue from 'vue'

const BUCKET_URL = (process.env.NODE_ENV === 'production')
  ? 'https://www.straitstimes.com/multimedia/graphics/json/'
  : 'https://st-graphics-dev-json.s3.ap-southeast-1.amazonaws.com/'

const store = Vue.observable({
  projectName: 'invisible-asians-series-2021', // Project name
  sessionId: null,
  panelList: null,
  BUCKET_URL
})

// Generate random string function
store.generateSessionId = function (length) {
  var randomID = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++) {
    randomID += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return randomID
}

// format topic
store.textFormat = function (text) {
  return text.replace(/:/g, '').replace(/\s+/g, '-').toLowerCase()
}


export {store}
